/**
 * Approval step (2026-09-22) — live count for the sidebar's "Replies to
 * approve" badge (= dashboard.kpis.awaitingApproval).
 *
 * Only runs when `enabled` (the current sidebar view actually shows the
 * item), so an LSP partner login never calls the staff dashboard — that path
 * is outside the partner fence. `refreshKey` re-fetches when it changes (the
 * Sidebar passes the pathname while inside /grievances, so approving a reply
 * and moving on refreshes the badge).
 */
import { useEffect, useState } from 'react';
import { staffApi } from './api';

export function useGrievanceApprovalCount(enabled: boolean, refreshKey: string): number | null {
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    staffApi
      .dashboard()
      .then((d) => { if (alive) setCount(d.kpis.awaitingApproval); })
      .catch(() => {});
    return () => { alive = false; };
  }, [enabled, refreshKey]);
  return enabled ? count : null;
}
